import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, Table, Td, Empty, StatusBadge, fmt } from "./AdminKit";
import { toast } from "sonner";

const statuses = ["pending", "bekreftet", "fullført", "kansellert"];
const priorityLabel = { akutt: "Акутт", hoy: "Высокий", normal: "Обычный" };
const priorityCls = { akutt: "bg-red-900/40 text-red-300 border-red-700/50", hoy: "bg-amber-900/40 text-amber-300 border-amber-700/50", normal: "bg-slate-700 text-slate-300 border-slate-600" };

export default function AdminBookings() {
  const [rows, setRows] = useState([]);
  const load = () => http.get("/v1/admin/bookings").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await http.put(`/v1/admin/bookings/${id}`, { status }); toast.success("Обновлено"); load(); }
    catch { toast.error("Ошибка"); }
  };

  const createOrder = async (id) => {
    try {
      const r = await http.post(`/v1/admin/bookings/${id}/create-order`);
      toast.success(r.data.already_linked ? `Уже связано: ${r.data.order_number}` : `Создан заказ ${r.data.order_number}`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Ошибка создания заказа"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-bookings">
      <h1 className="text-2xl font-bold text-white">Бронирования</h1>
      <Panel title={`Всего: ${rows.length} (срочные вверху)`}>
        {rows.length === 0 ? <Empty /> : (
          <Table head={["Приоритет", "Имя", "Тип", "Бизнес", "Дата", "Время", "Статус", "Заказ", "Действие"]}>
            {rows.map((r) => (
              <tr key={r.id} className={`border-b border-slate-700/50 ${r.priority === "akutt" ? "bg-red-950/20" : ""}`}>
                <Td><span className={`inline-block px-2 py-0.5 rounded-full text-xs border ${priorityCls[r.priority] || priorityCls.normal}`}>{priorityLabel[r.priority] || "Обычный"}</span></Td>
                <Td>{r.name}<div className="text-xs text-slate-500">{r.phone}{[r.machine_brand, r.machine_model].filter(Boolean).length ? ` · ${[r.machine_brand, r.machine_model].filter(Boolean).join(" ")}` : ""}</div></Td>
                <Td>{r.service_type}</Td>
                <Td>{r.is_business ? "да" : "-"}</Td>
                <Td>{r.preferred_date}</Td>
                <Td>{r.preferred_time}</Td>
                <Td><StatusBadge value={r.status} /></Td>
                <Td>
                  {r.repair_order_number
                    ? <span className="font-mono text-xs text-blue-300" data-testid={`booking-order-${r.id}`}>{r.repair_order_number}</span>
                    : <button onClick={() => createOrder(r.id)} data-testid={`booking-create-order-${r.id}`} className="px-2 py-1 rounded bg-blue-600/80 hover:bg-blue-600 text-white text-xs">Создать заказ</button>}
                </Td>
                <Td>
                  <select value={r.status} onChange={(e) => setStatus(r.id, e.target.value)} className="bg-slate-700 border border-slate-600 text-slate-200 rounded px-2 py-1 text-xs">
                    {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </Td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
